import { useEffect, useState } from 'react';
import { watchStorage } from './helpers';
export function useStorageWatcher({ storageType, methods, key }) {
    const [changed, setChanged] = useState();
    useEffect(() => {
        watchStorage({
            storage: window[storageType],
            methodsAvailable: [...methods],
            callbackAfter(method, keyChanged, args) {
                if (key === keyChanged)
                    setChanged({ method, keyChanged, args });
            },
        });
    }, [methods, storageType, key]);
    return changed;
}
//# sourceMappingURL=index.js.map